import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';

import { Container } from '@components/global';
import ExternalLink from '@common/ExternalLink';

import FacebookIcon from '@static/icons/facebook.svg';
import InstagramIcon from '@static/icons/instagram.svg';

const SOCIAL = [
  {
    icon: FacebookIcon,
    link: 'https://www.facebook.com/getsetthrive',
  },
  {
    icon: InstagramIcon,
    link: 'https://instagram.com/get.set.thrive?igshid=qj69b9xfcedb',
  },
];

const Footer = () => (
  <StaticQuery
    query={graphql`{
  art_pot: file(sourceInstanceName: {eq: "art"}, name: {eq: "customers_pot"}) {
    childImageSharp {
      gatsbyImageData(width: 960, placeholder: TRACED_SVG, layout: CONSTRAINED)
    }
  }
}
`}
    render={data => (
      <React.Fragment>
        <FooterWrapper>
          <StyledContainer>
            <Copyright>
              <span>Savleen Kaur</span>
              <br />
              <span>
                <ExternalLink href="mailto:coaching@getsetthrive.life">
                  coaching@getsetthrive.life
                </ExternalLink>
              </span>
              <br />
              <span>
                <ExternalLink href="tel:+61478989477">
                  0478 989 477
                </ExternalLink>
              </span>
              <br />
              <small>ABN: 27878856097 </small>
            </Copyright>
            <SocialIcons>
              {SOCIAL.map(({ icon, link }) => (
                <ExternalLink key={link} href={link}>
                  <img src={icon} alt="link" />
                </ExternalLink>
              ))}
            </SocialIcons>
          </StyledContainer>
        </FooterWrapper>
      </React.Fragment>
    )}
  />
);

const SocialIcons = styled.div`
  display: flex;

  img {
    margin: 0 8px;
    width: 24px;
    height: 24px;
  }

  @media (max-width: ${props => props.theme.screen.sm}) {
    margin-top: 40px;
  }
`;

const FooterWrapper = styled.footer`
  background-color: ${props => props.theme.color.primary};
  padding: 32px 0;
`;

const Copyright = styled.div`
  font-family: ${props => props.theme.font.secondary};
  ${props => props.theme.font_size.small};
  color: ${props => props.theme.color.black.regular};

  a {
    text-decoration: none;
    color: inherit;
  }
`;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${props => props.theme.screen.sm}) {
    flex-direction: column;
    text-align: center;
  }
`;

export default Footer;
